import { render, staticRenderFns } from "./chayan.vue?vue&type=template&id=ef2860a2&scoped=true"
import script from "./chayan.vue?vue&type=script&lang=js"
export * from "./chayan.vue?vue&type=script&lang=js"
import style0 from "./chayan.vue?vue&type=style&index=0&id=ef2860a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef2860a2",
  null
  
)

export default component.exports